<template>
	<div :class="{ 'menu-open': $store.state.isMenuOpen }" :style="{ 'margin-right': $store.state.isMenuOpen ? '25%' : '0%' }"> <!-- Aqui solução do layout! -->

		<h1>Substabelecimento de Processo</h1>
		<div class="container text-right" style="text-align: right; font-size: small;">
			<div style="display: flex; gap: 5px; flex-direction: row-reverse;">
				<button @click="GerarSubstabelecimento();"><u>G</u>erar Substabelecimento</button>
				<button @click="Imprimir();">Imp<u>r</u>imir</button>
				<button @click="Voltar();"><u>V</u>oltar</button>
			</div>
		</div>

		<p>Processo: {{ processo.codigo_processo }}</p>

		<div class="form-container mb-3" style="font-size: small;">
			<div class="form-title" style="background-color: gray; color: white; font-weight: bold;">Informações para o substabelecimento</div>

			<div class="row">
				<div class="col-4">
					<p>Tipo de substabelecimento:
						<br />
						<a v-if="!ehAdvogadoDoProcesso()" style="color: black; background-color: lightpink; margin-right: 2px; width: 50px;" class="btn btn-sm" type="button" @click="abrirModalInformativo()">
							<span class="material-icons">lock_person</span>
						</a>

						<input type="radio" id="sem-reserva" name="tipo_substabelecimento" v-model="tipoSubstabelecimento" :value="0" v-else />


						&nbsp;<label for="sem-reserva" class="sublinhado">Sem Reserva</label>





						<br /><input type="radio" id="com-reserva" name="tipo_substabelecimento" v-model="tipoSubstabelecimento" :value="1" />
						&nbsp;<label for="com-reserva" class="sublinhado">Com Reserva</label>
					</p>
				</div>
				<div class="col-4">
					<label for="com-reserva">Buscar por:</label><br />
					<select v-model="buscar_por" style="width: 200px;">
						<option value="Login">Login</option>
						<option value="Nome">Nome</option>
					</select>
					<br />
					<br /><input type="radio" id="buscar_advogado" name="buscar_por" v-model="rdo_buscar_por" value="advogado" />
					&nbsp;<label for="buscar_por_advogado">Advogado</label>
					<br /><input type="radio" id="soc_advogado" name="buscar_por" v-model="rdo_buscar_por" value="soc_advogado" />
					&nbsp;<label for="buscar_por_sociedade">Soc. Advogados</label>
					<br /><input type="radio" id="escritorio_pratica_juridica" name="buscar_por" v-model="rdo_buscar_por" value="escritorio_pratica_juridica" />
					&nbsp;<label for="buscar_por_escritorio">Escritório de Prática Jurídica</label>
					<br /><input type="radio" id="buscar_por_turma" name="buscar_por" v-model="rdo_buscar_por" value="grupo" />
					&nbsp;<label for="buscar_por_turma" title="Esta opção é exclusiva deste simulador e não estará presente no sistema oficial">Grupo <strong>**</strong></label>
					<br />

					<div class="position-relative">
						<input type="text" class="form-control" v-model="login_outro_usuario" @input="buscarUsuarios">
						<ul v-if="usuarios_pesquisados.length" class="list-group position-absolute">
							<li v-for="usuario in usuarios_pesquisados" :key="usuario.id" class="list-group-item" @click="selecionarUsuario(usuario)" style="cursor: pointer;">
								{{ usuario.name }} <span style="color: gray; font-size: smaller;">({{ usuario.email }})</span>
							</li>
						</ul>
						<ul v-if="grupos_pesquisados.length" class="list-group position-absolute">
							<li v-for="grupo in grupos_pesquisados" :key="grupo.id" class="list-group-item" @click="selecionarUsuario(grupo)" style="cursor: pointer;">
								{{ grupo.descricao }} <span style="color: gray; font-size: smaller;">
									Membros:
									<span v-for="membro in grupo.users">
										{{ (membro.id == grupo.users[grupo.users.length - 1].id) ? //Não coloca virgula de separar os membro no último. 
											membro.name : membro.name + ', '
										}}
									</span>
								</span>
							</li>
						</ul>
					</div>

				</div>
				<div class="col-4" style="display: flex; align-items: start; gap: 10px;">
					<select v-model="selectedAdvogados" style="width: 300px;" multiple>
						<option v-for="advogado in advogados_adicionados" :key="advogado.id" :value="advogado.id">
							{{ advogado.name }}
						</option>
					</select>
					<button @click="removerAdvogados" :disabled="advogados_adicionados.length === 0" style="background: none; border: none; cursor: pointer;" title="Selecione o usuário para removê-lo">
						<img :src="BASE_URL + 'imagens/icons/assuntos_remover.png'" width="20px" height="20px" />
					</button>
				</div>
			</div>
		</div>

		<div style="display:flex; justify-content: space-between;">
			<p style="font-size: small; color: gray; text-align: right; margin: 0px; padding: 0px;">
				Caso o Substabelecimento seja feito para representar uma das partes, é necessário selecioná-la no quadro a baixo
			</p>

			<p style="font-size: small; color: gray; text-align: right; margin: 0px; padding: 0px;">
				Lista de Partes (opcional) para definir o polo do substabelecimento ({{ partesDoAdvogado.length }} registros).
			</p>
		</div>
		<table class="table table-striped table-bordered mt-2 border" style="font-size: small;" id="printable-section">
			<thead>
				<tr class="text-center">
					<th scope="col" style="background-color: lightgrey; display: none;">id</th>
					<th scope="col" style="background-color: lightgrey;">
						<input type="checkbox" value="1" checked />
					</th>
					<th scope="col" style="background-color: lightgrey;">Parte Representada</th>
					<th scope="col" style="background-color: lightgrey;">Qualificação da Parte</th>
				</tr>
			</thead>
			<tbody>
				<tr v-if="!partesDoAdvogado.length">
					<td colspan="4" class="text-center" style="font-size: small;">
						Nenhuma parte disponível para seleção.
					</td>
				</tr>

				<tr v-for="parte in partesDoAdvogado" :key="parte.id">
					<td style="text-align: left; display: none;">{{ parte.id }}</td>
					<td scope="col" style="text-align: center;">
						<input type="checkbox" :value="parte" v-model="partesSelecionadas" />
					</td>
					<td style="text-align: left;">
						<div>
							<span class="parte_ativa">{{ parte.nome }}</span> -
							{{ parte.cpf_cnpj
								? (parte.cpf_cnpj.length > 14
									? '(' + parte.cpf_cnpj + ') Pessoa Jurídica'
									: '(' + parte.cpf_cnpj + ') Pessoa Física')
								: '(CPF/CNPJ não informado)'
							}}
						</div>
					</td>
					<td scope="col">{{ parte.tipo_req }}</td>
				</tr>
			</tbody>
		</table>

		<div class="container text-right" style="text-align: right; font-size: small;">
			<div style="display: flex; gap: 5px; flex-direction: row-reverse;">
				<button @click="GerarSubstabelecimento();"><u>G</u>erar Substabelecimento</button>
				<button @click="Imprimir();">Imp<u>r</u>imir</button>
				<button @click="Voltar();"><u>V</u>oltar</button>
			</div>
		</div>

		<p style="color: gray; font-size: small;"><strong style="color: black;">**</strong> Opção exclusiva deste simulador e não estará presente no sistema oficial.</p>


	</div>

	<!-- Modal (só aparece se mostrarModalInformativo = true) -->
	<div v-if="mostrarModalInformativo" class="modal-overlay" @click.self="fecharModalInformativo">
		<div class="modal-content">
			<div class="modal-header">
				<h5>Não é possível substabelecer sem reserva!</h5>
				<button class="close-btn" @click="fecharModalInformativo">x</button>
			</div>
			<div class="modal-body">
				<p style="text-align: justify;">
					O <strong>substabelecimento sem reserva</strong> ocorre quando o advogado transfere totalmente a representação do cliente para outro profissional. Nesse caso, o advogado original <strong>deixa de ter qualquer responsabilidade</strong> no processo.
					Para realizar esse tipo de substabelecimento, o advogado <strong>precisa estar vinculado ao processo</strong>, o que não é o seu caso no momento.
				</p>
				<p style="text-align: justify;">
					Já o <strong>substabelecimento com reserva</strong> permite apenas adicionar outro advogado ao caso, mantendo o vínculo e as responsabilidades dos atuais advogados.
				</p>
				<p style="text-align: justify;">
					Embora você não esteja vinculado ao processo, você pode adicionar outros advogados porque possui perfil <strong>administrador/professor</strong> neste simulador.
				</p>
			</div>
			<div class="modal-footer">
				<button class="btn-fechar" @click="fecharModalInformativo">Fechar</button>
			</div>
		</div>
	</div>



</template>

<script>

	export default {
		data() {
			return {
				BASE_URL: window.Laravel.baseUrl,
				tipoSubstabelecimento: '',
				buscar_por: 'Login',

				rdo_buscar_por: 'advogado',

				advogados_adicionados: [],
				login_outro_usuario: '',

				selectedAdvogados: [],

				usuarios_pesquisados: '',
				grupos_pesquisados: '',

				mostrarModalInformativo: false,
				partesSelecionadas: [],

			};
		},
		props: {
			user: {
				type: Object,
				required: true,
			},
			processo: {
				type: Object,
			},
		},
		methods: {
			abrirModalInformativo() {
				this.mostrarModalInformativo = true;
			},
			fecharModalInformativo() {
				this.mostrarModalInformativo = false;
			},

			Voltar() {
				window.location.href = this.BASE_URL + "processos/movimentacao_processual/" + this.processo.id;
			},
			Imprimir() {
				window.print();
			},
			buscarUsuarios() {
				if (this.login_outro_usuario.length > 2) { // Evita busca com poucos caracteres
					if (this.rdo_buscar_por == 'grupo') {
						axios.get(this.BASE_URL + 'buscar_grupos', {
							params: {
								filtro: this.login_outro_usuario,
								opcaoFiltro: 'descricao'
							}
						})
							.then(response => {
								this.grupos_pesquisados = response.data;
							})
							.catch(error => {
								console.error("Erro ao buscar grupos:", error);
							});
					} else {
						axios.get(this.BASE_URL + 'usuarios/buscar', { params: { query: this.login_outro_usuario } })
							.then(response => {
								this.usuarios_pesquisados = response.data;
							})
							.catch(error => {
								console.error("Erro ao buscar usuários:", error);
							});
					}
				} else {
					this.usuarios_pesquisados = [];
					this.grupos_pesquisados = []; // Limpa os grupos pesquisados
				}
			},
			selecionarUsuario(usuarioOuGrupo) {
				if (usuarioOuGrupo.users) {
					// Se for um grupo, adicionar todos os usuários do grupo
					usuarioOuGrupo.users.forEach(usuario => {
						const usuarioJaAdicionado = this.advogados_adicionados.some(u => u.id === usuario.id);
						if (!usuarioJaAdicionado) {
							this.advogados_adicionados.push({
								'name': usuario.name,
								'id': usuario.id,
								'email': usuario.email
							});
						}
					});
				} else {
					// Se for um usuário único
					const usuarioJaAdicionado = this.advogados_adicionados.some(u => u.id === usuarioOuGrupo.id);
					if (!usuarioJaAdicionado) {
						this.advogados_adicionados.push({
							'name': usuarioOuGrupo.name,
							'id': usuarioOuGrupo.id,
							'email': usuarioOuGrupo.email
						});
					}
				}

				this.usuarios_pesquisados = [];
				this.grupos_pesquisados = [];
				this.login_outro_usuario = '';
			},
			removerAdvogados() {
				this.advogados_adicionados = this.advogados_adicionados.filter(
					advogado => !this.selectedAdvogados.includes(advogado.id)
				);
				this.selectedAdvogados = []; // Limpar seleção após remoção
			},

			GerarSubstabelecimento() {
				if (this.tipoSubstabelecimento === '') {
					alert("Selecione o tipo de Substabelecimento.");
					return;
				}

				if (this.advogados_adicionados.length <= 0) {
					alert("Nenhum advogado foi adicionado.");
					return;
				}

				//Sem reserva o advogado sai fora do processo = 0
				//Com reserva adiciona mais advogados para trabalharem com ele = 1
				if (this.tipoSubstabelecimento == '0' && this.advogados_adicionados.length > 1) {
					alert("O substabelecimento sem reservas não pode ter mais de um advogado adicionado.");
					return;
				}

				// Monta um payload mais leve para as partes
				const partes_selecionadas = this.partesSelecionadas.map(parte => ({
					id: parte.id,
					// Se quiser mandar só o polo, basta isso:
					tipo_req: parte.tipo_req, // 'REQUERENTE' ou 'REQUERIDO'
					polo_ativo: parte.pivot ? parte.pivot.polo_ativo : 0,
					polo_passivo: parte.pivot ? parte.pivot.polo_passivo : 0,
				}));

				const dados = {
					tipoSubstabelecimento: this.tipoSubstabelecimento,
					advogados_adicionados: this.advogados_adicionados,
					id_advogado_atual: this.user.id,
					processo_id: this.processo.id,
					partes_selecionadas: partes_selecionadas,
				};

				axios.post(this.BASE_URL + 'processos/substabelecer_advogados', dados)
					.then(response => {
						alert('Substabelecimento gerado com sucesso.');
						window.location.href = this.BASE_URL + "processos/movimentacao_processual/" + this.processo.id;
					})
					.catch(error => {
						// Erro
						console.error('Erro ao enviar os dados:', error);
						alert('Erro ao efetivar o substabelecimento.');
					});
			},

			ehAdvogadoDoProcesso() {
				return this.user
					&& Array.isArray(this.processo.advogados)
					&& this.processo.advogados.some(adv =>
						String(adv.id) === String(this.user.id)
					);
			},

		},
		mounted() {

		},
		computed: {
			partesDoAdvogado() {
				if (!this.processo || !this.user) {
					return [];
				}

				// Exibe sempre todas as partes do processo (autor e réu).
				return this.processo.partes.map(parte => {
					let tipo_req = 'PARTE';

					if (parte.pivot) {
						if (parte.pivot.polo_ativo === 1) {
							tipo_req = 'REQUERENTE';
						} else if (parte.pivot.polo_passivo === 1) {
							tipo_req = 'REQUERIDO';
						}
					}

					return { ...parte, tipo_req };
				});
			},
		}

	};
</script>

<style scoped>
	h1 {
		font-size: 26px;
	}

	.form-container {
		border: 1px solid gray;
		/* Borda fina cinza */
		padding: 10px;
		position: relative;
		/* Posição relativa para o posicionamento do título */
		margin-top: 5px;
		/* Espaçamento superior para visualização do título */
		margin-left: 5px;
		margin-right: 5px;
		border-radius: 5px;
		background-color: #FFFFFF;
	}

	.form-title {
		position: absolute;
		/* Posicionamento absoluto do título */
		top: -15px;
		/* Posiciona o título acima da borda */
		left: 10px;
		/* Espaçamento da esquerda para o título */
		background: white;
		/* Fundo branco para o título */
		padding: 0 1px;
		/* Espaçamento interno do título */
		font-weight: bold;
		;
	}

	.position-relative {
		position: relative;
	}

	.position-absolute {
		position: absolute;
		z-index: 1000;
		background-color: white;
		/* Para evitar sobreposição com outros elementos */
		width: 100%;
		/* Ajusta a largura da lista para coincidir com o campo de entrada */
		max-height: 200px;
		/* Limite de altura para a lista de sugestões */
		overflow-y: auto;
		/* Adiciona rolagem se a lista for muito longa */
	}

	.sublinhado:hover {
		text-decoration: underline;
	}


	/*Modal informativo */
	.modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.45);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 9999;
	}

	.modal-content {
		background: white;
		width: 480px;
		border-radius: 10px;
		overflow: hidden;
		box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
	}

	.modal-header {
		padding: 10px 15px;
		background: #f8f8f8;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.close-btn {
		background: none;
		border: none;
		font-size: 22px;
		cursor: pointer;
	}

	.modal-body {
		padding: 15px;
		font-size: 15px;
		color: #333;
	}

	.modal-footer {
		padding: 10px 15px;
		background: #f8f8f8;
		text-align: right;
	}

	.btn-fechar {
		background: #555;
		color: white;
		border: none;
		padding: 6px 12px;
		border-radius: 6px;
		cursor: pointer;
	}

</style>
